// src/examples/Sidenav/index.js
import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
} from "@mui/material";
import { NavLink } from "react-router-dom";

function Sidenav({ brandName, routes }) {
  return (
    <Box
      sx={{
        width: 250,
        backgroundColor: "#1F283E",
        color: "#fff",
        height: "100vh",
        p: 2,
        borderRadius: "10px",
      }}
    >
      <Box sx={{ mb: 1, textAlign: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {brandName}
        </Typography>
      </Box>
      <Divider sx={{ borderColor: "#4C5365", mb: 1 }} />
      <style>
        {`
          .nav-active .MuiListItemButton-root {
            background-color: #E63572 !important;
          }
          .nav-inactive .MuiListItemButton-root:hover {
            background-color: #4C5365 !important;
          }
        `}
      </style>
      <List>
        {routes.map((route) => (
          <ListItem key={route.key} disablePadding sx={{ mb: 1 }}>
            <NavLink
              to={route.route}
              className={({ isActive }) => (isActive ? "nav-active" : "nav-inactive")}
              style={{ width: "100%", textDecoration: "none", color: "inherit" }}
            >
              <ListItemButton sx={{ borderRadius: 1 }}>
                <ListItemIcon sx={{ color: "#fff" }}>{route.icon}</ListItemIcon>
                <ListItemText primary={route.name} />
              </ListItemButton>
            </NavLink>
          </ListItem>
        ))}
      </List>
      <Box sx={{ mt: "auto", mb: 2, textAlign: "center" }}>
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          © 2025 SafeAlert
        </Typography>
      </Box>
    </Box>
  );
}

Sidenav.propTypes = {
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.array.isRequired,
};

export default Sidenav;
